/**
 * Scroll reset for the profile frame
 *
 * Every page under /profile wraps its content in
 * `turbo_frame_tag 'profile-frame', data: { turbo_action: 'advance' }`, so following a
 * link there is a frame navigation rather than a Drive visit. Turbo skips its scroll
 * reset for exactly that case: a frame navigating with an action proposes a visit with
 * `willRender: false`, and Visit sets `scrolled = !willRender`, which makes
 * `performScroll()` a no-op. The URL advances and the content swaps, but the window
 * offset is left untouched - so clicking Edit from halfway down the dealer worklist
 * lands you halfway down the edit form.
 *
 * Turbo's own escape hatch, the frame's `autoscroll` attribute, is the wrong tool here:
 * it calls `scrollIntoView` on the frame's first child, which tucks the content under
 * the sticky navbar. Top of the window is what a Drive visit would have done.
 */
const FRAME_ID = 'profile-frame'

/**
 * `turbo:frame-render` bubbles, and profile-frame nests other frames inside it -
 * 'listing-link-check' on the dealer form, 'customer-number-check' on the account form,
 * 'search-results' on several admin tools. Those load while somebody is working the page
 * and must not move the viewport, hence the id check rather than a bare listener.
 */
document.addEventListener('turbo:frame-render', (event) => {
  const frame = event.target

  if (frame.id !== FRAME_ID) return

  // A refused save re-renders this frame too, and the response nominates what to land on
  // by marking it focus-on-load - the error summary, in that case. That controller's
  // scroll runs inside Turbo's render, which finishes before this event fires, so
  // resetting unconditionally would scroll away from the error the save just reported.
  // Whoever asked to be landed on wins.
  if (frame.querySelector('[data-controller~="focus-on-load"]')) return

  // Instant, not smooth: this stands in for a page visit, and a visit does not animate.
  window.scrollTo({ top: 0, behavior: 'auto' })
})
